module.exports = {
    table: {
        Table: require('./table/table.js'),
        TableFixedHead: require('./table/tableFixedHead.js'),
        TableFixedHeadBase: require('./table/tableFixedHeadBase.js'),
        ScrollTable: require('./table/scrollTable.js'),
        CollapseTable: require('./table/collapseTable.js')
    },
    dialog: {
        Dialog: require('./dialog/dialog'),
        Prompt: require('./dialog/prompt'),
        Modal: require('./dialog/modal')
    },
    button: {
        Button: require('./button/index')
    },
    datepicker: {
        Datepicker: require('./datepicker/index'),
        Group: require('./datepicker/group')
    },
    checkbox: {
        CheckBox: require('./checkbox/index'),
        List: require('./checkbox/list')
    },
    input: {
        Input: require('./input/index'),
        InputGroup: require('./input/group'),
        InputUnit: require('./input/unit')
    },
    textarea: {
        Textarea: require('./textarea/index.js')
    },
    select: {
        Select: require('./select/index')
    },
    selectMultiple: {
        SelectMultiple: require('./selectMultiple/index')
    },
    pagination: {
        Pagination: require('./pagination/index'),
        Form: require('./pagination/form'),
        Items: require('./pagination/items')
    },
    tabPage: {
        TabPage: require('./tabPage/index')
    },
    grid: {
        Row: require('./grid/row'),
        Col: require('./grid/col')
    },
    radio: {
        Radio: require('./radio/radio')
    },
    queryform: {
        Queryform: require('./queryform/queryform'),
        FormItem: require('./queryform/formItem')
    },
    numberCount: {
        NumberCount: require('./numberCount/index')
    },
    uploader: {
        Uploader: require('./uploader/uploader')
    },
    tree: {
        Tree: require('./tree/index'),
        Tree2: require('./tree/index2')
    },
    frame: {
        Frame: require('./frame/frame.js'),
        Frame2: require('./frame/frame2.js'),
        Frame3: require('./frame/frame_nofoot.js')
    },
    switchItem: {
        SwitchItem: require('./switch/index.js')
    },
    collapse: {
        Collapse: require('./collapse/collapse.js'),
        Panel: require('./collapse/panel.js')
    },
    toolTip: {
        ToolTip: require('./toolTip/index.js'),
    },
    imgDialog: {
        ImgDialog: require('./imgDialog/index.js'),
    },
};




// WEBPACK FOOTER //
// ./component/index.js